import { useSettings } from './useSettings';
import { DEFAULT_TIME_PREFS, type TimePrefs } from '@/lib/time-format';

// Resolves the user's clock-display preferences. Falls back to sensible
// defaults (24h, no seconds) while settings are loading or unavailable
// so first-paint never blocks waiting on a network roundtrip.
export function useTimePrefs(): TimePrefs {
  const { data } = useSettings();
  if (!data) return DEFAULT_TIME_PREFS;
  return { timeFormat: data.timeFormat, showSeconds: data.showSeconds };
}
